
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { StaffTable } from "@/components/staff/staff-table"
import { AddStaffDialog } from "@/components/staff/add-staff-dialog"
import { PlusIcon, SearchIcon } from "lucide-react"
import { PageHeader } from "@/components/shared/page-header"

export default function StaffPage() {
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState("")
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  return (
    <div className="space-y-6">
      <PageHeader title={t("staff.staffManagement")}>
        <div className="relative w-full sm:w-64">
          <SearchIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            type="search"
            placeholder={t("staff.searchStaff")}
            className="pl-8"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <Button onClick={() => setAddDialogOpen(true)} className="w-full sm:w-auto">
          <PlusIcon className="mr-2 h-4 w-4" />
          {t("staff.addStaff")}
        </Button>
      </PageHeader>

      <Card>
        <CardHeader>
          <CardTitle>{t("staff.title")}</CardTitle>
          <CardDescription>{t("staff.addStaffDescription")}</CardDescription>
        </CardHeader>
        <CardContent>
          <StaffTable searchQuery={searchQuery} onRefresh={handleRefresh} />
        </CardContent>
      </Card>

      <AddStaffDialog open={addDialogOpen} onOpenChange={setAddDialogOpen} onSuccess={handleRefresh} />
    </div>
  )
}
